import { API } from '@repo/hooks';
import type { AssetType } from '@repo/types/asset';
import type { AssetRetrievalDraft, AssetRetrievalOrder, AssetRetrievalQuotation } from '@repo/types/asset-retrieval';
import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { retrieveDraft, retrieveOrder, retrieveQuotation } from '@/api/asset-retrieval.api';

export function useAssetRetrieval(
    assetType: 'order',
    assetId: string,
    enabled: boolean
): UseQueryResult<AssetRetrievalOrder>;
export function useAssetRetrieval(
    assetType: 'draft',
    assetId: string,
    enabled: boolean
): UseQueryResult<AssetRetrievalDraft>;
export function useAssetRetrieval(
    assetType: 'quote',
    assetId: string,
    enabled: boolean
): UseQueryResult<AssetRetrievalQuotation>;
export function useAssetRetrieval(
    assetType: AssetType,
    assetId: string,
    enabled: boolean
): UseQueryResult<AssetRetrievalOrder | AssetRetrievalDraft | AssetRetrievalQuotation>;
export function useAssetRetrieval(assetType: AssetType, assetId: string, enabled: boolean) {
    return useQuery({
        enabled,
        queryKey: [API.assetRetrieval, assetType, assetId],
        queryFn: async () => {
            if (assetType === 'order') {
                return await retrieveOrder(assetId);
            }

            if (assetType === 'draft') {
                return await retrieveDraft(assetId);
            }

            return await retrieveQuotation(assetId);
        },
    });
}
